module.exports = __webpack_public_path__ + "img/undraw_authentication_fsn5.8505f7b7.svg";